const validatePage4 = (values) => {
    const errors = {};
    if (!values.tieneContratoLaboral) {
        errors.tieneContratoLaboral =
            "Este campo es requerido, indique si tiene contrato laboral";
    }
    if (values.tieneContratoLaboral?.id === 30) {
        if (!values.tipoContrato) {
            errors.tipoContrato =
                "Este campo es requerido, indique que tipo de contrato";
        }
    }
    if (!values.ingresosActuales) {
        errors.ingresosActuales =
            "Este campo es requerido, indique sus ingresos actuales";
    }
    return errors;
};

export default validatePage4;
